import { IRootProps } from "../interfaces";

export default function LayoutPlansAndAppsUsers({ children }: IRootProps) {
  return <>{children}</>;
}
